import { createContext, useContext, useState, useCallback, ReactNode } from 'react';
import { contasBancariasIniciais, ContaBancaria } from '../mocks/contasBancarias';

interface ContasBancariasContextData {
  contas: ContaBancaria[];
  definirPrincipal: (id: number) => void;
  adicionarConta: (conta: Omit<ContaBancaria, 'id'>) => void;
  removerConta: (id: number) => void;
}

const ContasBancariasContext = createContext<ContasBancariasContextData | null>(null);

export function ContasBancariasProvider({ children }: { children: ReactNode }) {
  const [contas, setContas] = useState<ContaBancaria[]>(contasBancariasIniciais);

  const definirPrincipal = useCallback((id: number) => {
    setContas((prev) => prev.map((c) => ({ ...c, principal: c.id === id })));
  }, []);

  const adicionarConta = useCallback((novaConta: Omit<ContaBancaria, 'id'>) => {
    setContas((prev) => {
      const novoId = prev.length > 0 ? Math.max(...prev.map((c) => c.id)) + 1 : 1;
      return [...prev, { ...novaConta, id: novoId }];
    });
  }, []);

  const removerConta = useCallback((id: number) => {
    setContas((prev) => prev.filter((c) => c.id !== id));
  }, []);

  return (
    <ContasBancariasContext.Provider value={{ contas, definirPrincipal, adicionarConta, removerConta }}>
      {children}
    </ContasBancariasContext.Provider>
  );
}

export function useContasBancarias() {
  const ctx = useContext(ContasBancariasContext);
  if (!ctx) throw new Error('useContasBancarias deve ser usado dentro de ContasBancariasProvider');
  return ctx;
}
